export enum PatientChannel {
  CREATE = 'patient::create',
  EDIT = 'patient::patch',
  DELETE = 'patient::delete',
}
